
// Table Container color
export const TableContStyle = {backgroundColor:"#E2ECEB" }
export const TableHeadStyle = {backgroundColor: "#b2dae5", fontSize: 18, fontWeight: 600}

// {TableContStyle, TableHeadStyle }